import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useLaboratories() {
  const navigate = useNavigate();

  const [laboratories, setLaboratories] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Returns the promise (resolved with the list) for callers that act right after the refetch,
  // such as selecting a laboratory just added from another form.
  const fetchLaboratories = useCallback(() => {
    setLoading(true);
    return quarkusApi
      .get('/laboratories', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        setLaboratories(returnFromApi.data);
        return returnFromApi.data;
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchLaboratories();
  }, [fetchLaboratories]);

  return { laboratories, isLoading, error, refetch: fetchLaboratories };
}
